/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Style_Preset_AriaInputs */



/**
* | output |
* | --- |
* | "Style Preset Selection" |
*
* @param {Video_Export_Style_Preset_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_style_preset_aria = /** @type {((inputs?: Video_Export_Style_Preset_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Style_Preset_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selection du prereglage de style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stilvoreinstellungsauswahl")
	if (locale === "it") return /** @type {LocalizedString} */ ("Selezione predefinita di stile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбор предустановленного стиля")
	if (locale === "es") return /** @type {LocalizedString} */ ("Selección de ajustes preestablecidos de estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("样式预设选择")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルプリセットの選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टाइल प्रीसेट चयन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Seleção de predefinições de estilo")
	return /** @type {LocalizedString} */ ("Style Preset Selection")
});